import { useEffect, useState } from "react";
import ArgosFlexbox from "../../Containers/ArgosFlexbox";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import ArgosMenuItem from "../../Form/Select/ArgosMenuItem";
import ListItemText from "@mui/material/ListItemText";
import ArgosButton from "../../Buttons/ArgosButton";
/**
  * Dialog to delete a category group                                                                
  * @param props 
  *   - data: data of the category group
  *  - onSave: function to save the data
  * - onClose: function to close the dialog
  * @returns
  * Dialog to delete a category group
  *   - Select the category to delete
  *  - Delete the category    
  * - Cancel the dialog
  *
  * @example
  * ```tsx  
  * 
  * <DeleteCategoryGroupDialog
  *  data={data}  
  *   onSave={saveData}
  *   onClose={closeDialog}  
  * />    
  *   
  * ```
  */ 

const DeleteCategoryGroupDialog = (props: any) => {
  
  const [selectedCategory, setSelectedCategory] = useState<string>("")
  const [objCats, setObjCats] = useState<any>([]);
  /**
   * Set the categories in the select
   * @param props.data.original.subRows
   */
  useEffect(() => {
    const categories = props.data.original.subRows.map((item: { category: any; }) => item.category)
    const unique = [...new Set(categories)];
    setObjCats(unique);
  }, [])
  /**
   * Handle the change of the category
   * @param event
   */
  const handleCategoryChange = (event: any) => {
    const value = event.target.value
    setSelectedCategory(value)

  }
  /**
   * Pass the data back to onSave deleting the selected category
   */
  const saveData = () => {
    
    const element = {"original":{"category":selectedCategory, "subRows": props.data.original.subRows.filter((item: { category: any; }) => item.category === selectedCategory)}};
    
    props.onSave("deleteProperty", element)
    props.onClose()
  }
  const WIDTH = 400
  return (

      <ArgosFlexbox vertical style={{justifyContent: "center", alignItems: "center"}}>
        <FormControl sx={{width: WIDTH}}>
          <InputLabel id="category-select-label">
            Category
          </InputLabel>
          <Select
            labelId="category-select-label"
            id="category-select"
            value={selectedCategory}
            label="Category"
            onChange={handleCategoryChange}
            variant="standard"
          >
            {objCats.map((option: string) => (
              <ArgosMenuItem key={option} value={option}>
                <ListItemText
                  primary={option}
                />
              </ArgosMenuItem>
            ))}
          </Select>
        </FormControl>
        <ArgosFlexbox>
          <ArgosButton onClick={() => props.onClose()}>
            Cancel
          </ArgosButton>
          {selectedCategory && 
          <ArgosButton onClick={() => saveData()}>
            Delete
          </ArgosButton>}
        </ArgosFlexbox>
      </ArgosFlexbox>
  );
}
export default DeleteCategoryGroupDialog;